import { render } from "./WidescreenHolder.vue?vue&type=template&id=5ae8afcc&scoped=true"
import script from "./WidescreenHolder.vue?vue&type=script&lang=js"
export * from "./WidescreenHolder.vue?vue&type=script&lang=js"

import "./WidescreenHolder.vue?vue&type=style&index=0&id=5ae8afcc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ae8afcc"

export default script